// Holds the member's active branch id (sent by axios as the `branch-id` header).
// Persisted to localStorage so the selection survives a page reload / LIFF
// re-entry (QTY-1894); LineBranchContext seeds its state from getActiveBranchId()
// and its reconcile effect snaps to a valid branch if the stored one no longer
// belongs to the current member.
const BRANCH_STORAGE_KEY = "active-branch-id";

const readStoredBranchId = (): string => {
  try {
    return globalThis.localStorage.getItem(BRANCH_STORAGE_KEY) || "1";
  } catch {
    return "1";
  }
};

let activeBranchId = readStoredBranchId();

export const getActiveBranchId = (): string => activeBranchId;

export const setActiveBranchId = (id: string): void => {
  activeBranchId = id;
  try {
    globalThis.localStorage.setItem(BRANCH_STORAGE_KEY, id);
  } catch {
    // no-op for non-browser environments
  }
};

// Reset the active branch on logout / forced re-login so the next member on
// this device doesn't inherit the previous member's branch. Clears both the
// in-memory value (localStorage.clear() alone can't reach it) and the stored key.
export const clearActiveBranchId = (): void => {
  activeBranchId = "1";
  try {
    globalThis.localStorage.removeItem(BRANCH_STORAGE_KEY);
  } catch {
    // no-op for non-browser environments
  }
};

// Per-request override of the global `branch-id` header (the axios interceptor
// only fills it when unset). Actions on an existing booking must run in the
// booking's own branch, not whichever branch the member has selected (QTY-2107).
export const branchHeaders = (
  branchId?: string | number | null,
): { headers?: Record<string, string> } =>
  branchId ? { headers: { "branch-id": String(branchId) } } : {};
